import { Button, RouteLink } from "../../ui";

export type TPublicNavbarActionsProps = {
  isAuthenticated: boolean;
  variant: "desktop" | "mobile";
};

const GUEST_ACTIONS = [
  { to: "/auth/login", label: "Login" },
  { to: "/auth/signup", label: "Register" },
] as const;

const AUTHENTICATED_ACTIONS = [
  { to: "/app", label: "Dashboard" },
  { to: "/app/settings", label: "Settings" },
] as const;

type TNavbarAction = (typeof GUEST_ACTIONS)[number] | (typeof AUTHENTICATED_ACTIONS)[number];

export function PublicNavbarActions({ isAuthenticated, variant }: TPublicNavbarActionsProps) {
  const actions = isAuthenticated ? AUTHENTICATED_ACTIONS : GUEST_ACTIONS;

  const renderAction = (action: TNavbarAction, index: number) => {
    const isPrimary = index === 1;

    if (variant === "desktop") {
      return (
        <RouteLink
          key={action.to}
          to={action.to}
        >
          <Button
            variant={isPrimary ? "default" : "ghost"}
            className={
              isPrimary
                ? "h-10 rounded-full bg-primary px-6 text-sm font-medium text-primary-foreground hover:bg-primary/90"
                : "h-10 rounded-full px-6 text-sm font-medium text-foreground hover:bg-accent"
            }
          >
            {action.label}
          </Button>
        </RouteLink>
      );
    }

    // mobile
    return (
      <RouteLink
        key={action.to}
        to={action.to}
      >
        <Button
          variant={isPrimary ? "default" : "outline"}
          className={
            isPrimary
              ? "w-full bg-primary text-primary-foreground hover:bg-primary/90"
              : "w-full border border-border bg-card text-foreground hover:bg-accent"
          }
        >
          {action.label}
        </Button>
      </RouteLink>
    );
  };

  if (variant === "desktop") {
    return (
      <div className="hidden items-center rounded-full bg-card/90 p-1.5 shadow-md ring-1 ring-black/5 backdrop-blur lg:flex">
        {actions.map(renderAction)}
      </div>
    );
  }

  return <div className="flex flex-col gap-2">{actions.map(renderAction)}</div>;
}
